import { UseControllerProps, ValidateResult } from 'react-hook-form'

import { ValidationMessageWithMask } from 'elements/TextField/interface'

type ExtendedUseControllerProps = UseControllerProps & {
  rules: UseControllerProps['rules'] &
    Partial<{ validate: { equal: (value: string) => ValidateResult | Promise<ValidateResult> } }>
}

export default function addMaskRules(
  rules: UseControllerProps['rules'],
  mask?: ValidationMessageWithMask
): ExtendedUseControllerProps['rules'] {
  if (mask === undefined) {
    return rules as ExtendedUseControllerProps['rules']
  }

  return {
    ...rules,
    validate: {
      ...rules?.validate,
      equal: (value: string) => {
        const cleanValue = (value: string): string => value.replace(/[_/-]/g, '')
        const isValueFilled = cleanValue(value).length === cleanValue(mask.value).length

        if (!isValueFilled && cleanValue(value).length > 0) {
          return mask.message ?? `Value must be in the required format: ${mask.value}`
        }

        if (rules?.validate === undefined || !('equal' in rules.validate)) {
          return true
        }

        return rules.validate.equal(value)
      },
    },
  }
}
